import React, { Component, Dispatch } from 'react';
import { SofaPanel } from '@sofology/sofologycomponents';
import { connect } from 'react-redux';

import './OrderSummaryPanel.scss';

import { OrderSummaryItems, CheckoutEstimate, CheckoutOrderTotal } from 'components';
import { generateDispatchToPropsMap, paymentHelper } from 'helpers';
import { AppState } from 'store';
import { BasketDetailsModel } from 'models/Basket';
import { clearDeliverNotBefore, ClearDeliverNotBeforeFunc } from 'store/checkout/actions';
import { PaymentDetailsModel } from 'models/Payment';

interface OwnProps {
    useDateFromApi?: boolean;
}

interface StateProps {
    basket: BasketDetailsModel;
    paymentDetails: PaymentDetailsModel;
    deliverNotBefore: Date | null;
}

interface DispatchProps {
    clearDeliverNotBefore: ClearDeliverNotBeforeFunc;
}

class OrderSummaryPanel extends Component<OwnProps & StateProps & DispatchProps> {
    componentDidMount() {
        this.props.clearDeliverNotBefore();
    }

    render(): JSX.Element | null {
        const { basket, useDateFromApi, deliverNotBefore, paymentDetails } = this.props;
        const deliverNotBeforeDate = useDateFromApi ? (basket.eca ? new Date(basket.eca) : null) : deliverNotBefore;

        return (
            <div className='order-summary-panel'>
                <SofaPanel>
                    <OrderSummaryItems />
                    <div className='order-summary-panel__info'>
                        {
                            <CheckoutEstimate
                                leadTime={basket.leadTime}
                                deliveryCost={basket.deliveryCost?.value}
                                deliverNotBefore={deliverNotBeforeDate}
                                hasQuickstockItem={basket.hasQuickstockItem()}
                            />
                        }
                        {
                            paymentHelper.isCardRelatedPaymentType(paymentDetails.paymentType)
                            && <CheckoutOrderTotal
                                paymentDetails={paymentDetails}
                                discounts={basket.totalDiscounts}
                            />
                        }
                    </div>
                </SofaPanel>
            </div>
        );
    }
}

function mapStateToProps(state: AppState): StateProps {
    return {
        basket: state.basketState.basket!,
        paymentDetails: state.paymentState.paymentDetails,
        deliverNotBefore: state.checkoutState.deliverNotBefore
    };
}

function mapDispatchToProps(dispatch: Dispatch<any>): DispatchProps {
    return generateDispatchToPropsMap(dispatch, [clearDeliverNotBefore]);
}

export default connect(mapStateToProps, mapDispatchToProps)(OrderSummaryPanel);